import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const finalpdfformsAdapter = createEntityAdapter({})

const initialState = finalpdfformsAdapter.getInitialState()

export const finalpdfformsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getfinalpdfform: builder.query({
            query: () => ({
                url: '/finalpdfforms',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedfinalpdfform = responseData.map(finalpdfform => {
                    // console.log(finalpdfform)
                    finalpdfform.id = finalpdfform._id
                    // console.log(finalpdfform)
                    return finalpdfform
                });
                return finalpdfformsAdapter.setAll(initialState, loadedfinalpdfform)
            },
            providesTags: (result, error, arg) => {
                console.log(result.ids) 
                if (result?.ids) {
                    return [
                        { type: 'FINALPDFFORM', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'FINALPDFFORM', id }))
                    ]
                } else return [{ type: 'FINALPDFFORM', id: 'LIST' }]
            }
        }),
        addNewfinalpdfform: builder.mutation({
            query: initialUserData => ({
                url: '/finalpdfforms',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'FINALPDFFORM', id: "LIST" }
            ]
        }),        
        updatefinalpdfform: builder.mutation({
            query: initialUserData => ({
                url: '/finalpdfforms',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'FINALPDFFORM', id: arg.id }
            ]
        }),        
        deletefinalpdfform: builder.mutation({
            query: ({ id }) => ({
                url: `/finalpdfforms`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'FINALPDFFORM', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetfinalpdfformQuery,
    useAddNewfinalpdfformMutation,
    useUpdatefinalpdfformMutation,
    useDeletefinalpdfformMutation,
} = finalpdfformsApiSlice

// returns the query result object
export const selectfinalpdfformResult = finalpdfformsApiSlice.endpoints.getfinalpdfform.select()

// creates memoized selector
const selectfinalpdfformData = createSelector(
    selectfinalpdfformResult,
    finalpdfformResult => finalpdfformResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllpdfforms,
    selectById: selectpdfformsById,
    selectIds: selectpdfformsIds
    // Pass in a selector that returns the users slice of state
} = finalpdfformsAdapter.getSelectors(state => selectfinalpdfformData(state) ?? initialState)